import { useState } from "react";
import "./Footer.scss";
import { useTranslation } from "react-i18next";

export default function Footer({ openDeliveryPopup, setOpenDeliveryPopup }) {
  const { t } = useTranslation();
  return (
    <footer>
      <div className="left">
        <div className="title">
          <p>{t("information")}</p>
        </div>
        <div className="content">
          <a href="/terms">{t("terms-and-conditions")}</a>
          <a
            onClick={() => {
              setOpenDeliveryPopup(true);
            }}
          >
            Доставка
          </a>
        </div>
      </div>
      <div className="middle">
        <div className="title">
          <p>{t("contacts")}</p>
        </div>
        <div className="content">
          <div className="icon-element">
            <div className="icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="33"
                height="32"
                viewBox="0 0 33 32"
                fill="none"
              >
                <path
                  d="M16.9025 23.8043L17.3552 24.6959L17.3552 24.6959L16.9025 23.8043ZM16.0975 23.8043L15.6448 24.6959L15.6448 24.6959L16.0975 23.8043ZM24.8333 11.9998C24.8333 15.05 23.2438 17.5333 21.3364 19.4153C19.4312 21.2952 17.3002 22.4808 16.4498 22.9126L17.3552 24.6959C18.2937 24.2194 20.6282 22.9238 22.7411 20.839C24.8519 18.7563 26.8333 15.7914 26.8333 11.9998H24.8333ZM16.5 3.6665C21.1024 3.6665 24.8333 7.39746 24.8333 11.9998H26.8333C26.8333 6.29289 22.2069 1.6665 16.5 1.6665V3.6665ZM8.16667 11.9998C8.16667 7.39746 11.8976 3.6665 16.5 3.6665V1.6665C10.7931 1.6665 6.16667 6.29289 6.16667 11.9998H8.16667ZM16.5502 22.9126C15.6998 22.4808 13.5689 21.2952 11.6636 19.4153C9.75619 17.5333 8.16667 15.05 8.16667 11.9998H6.16667C6.16667 15.7914 8.14811 18.7563 10.2589 20.839C12.3718 22.9238 14.7063 24.2194 15.6448 24.6959L16.5502 22.9126ZM16.4498 22.9126C16.4803 22.8971 16.5197 22.8971 16.5502 22.9126L15.6448 24.6959C16.1833 24.9693 16.8167 24.9693 17.3552 24.6959L16.4498 22.9126ZM19.5 11.9998C19.5 13.6567 18.1569 14.9998 16.5 14.9998V16.9998C19.2614 16.9998 21.5 14.7613 21.5 11.9998H19.5ZM16.5 8.99984C18.1569 8.99984 19.5 10.343 19.5 11.9998H21.5C21.5 9.23841 19.2614 6.99984 16.5 6.99984V8.99984ZM13.5 11.9998C13.5 10.343 14.8432 8.99984 16.5 8.99984V6.99984C13.7386 6.99984 11.5 9.23841 11.5 11.9998H13.5ZM16.5 14.9998C14.8432 14.9998 13.5 13.6567 13.5 11.9998H11.5C11.5 14.7613 13.7386 16.9998 16.5 16.9998V14.9998Z"
                  fill="#343434"
                />
                <path
                  d="M26.8923 23.3335C27.9455 23.9416 28.5 24.6313 28.5 25.3335C28.5 26.0356 27.9455 26.7254 26.8923 27.3335C25.8391 27.9416 24.3242 28.4465 22.5 28.7976C20.6758 29.1487 18.6064 29.3335 16.5 29.3335C14.3936 29.3335 12.3242 29.1487 10.5 28.7976C8.67577 28.4465 7.16092 27.9416 6.1077 27.3335C5.05448 26.7254 4.5 26.0356 4.5 25.3335C4.5 24.6313 5.05447 23.9416 6.10769 23.3335"
                  stroke="#343434"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </svg>
            </div>
            <div className="info">
              <p>{t("address")}</p>
            </div>
          </div>
          <div className="icon-element">
            <div className="icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="34"
                height="33"
                viewBox="0 0 34 33"
                fill="none"
              >
                <path
                  d="M4.17962 4.43149L6.904 1.70711C7.29453 1.31658 7.92769 1.31658 8.31822 1.70711L14.0151 7.404C14.4056 7.79453 14.4056 8.42769 14.0151 8.81822L11.6498 11.1836C11.3613 11.4721 11.2897 11.9128 11.4722 12.2777C13.5818 16.497 17.003 19.9182 21.2223 22.0278C21.5872 22.2103 22.0279 22.1387 22.3164 21.8502L24.6818 19.4849C25.0723 19.0944 25.7055 19.0944 26.096 19.4849L31.7929 25.1818C32.1834 25.5723 32.1834 26.2055 31.7929 26.596L29.0685 29.3204C26.9572 31.4317 23.6146 31.6693 21.2259 29.8777L13.7952 24.3048C12.0517 22.9971 10.5029 21.4483 9.19524 19.7048L3.62226 12.2741C1.83072 9.88541 2.06827 6.54284 4.17962 4.43149Z"
                  stroke="#343434"
                  strokeWidth="2"
                />
              </svg>
            </div>
            <div className="info">
              <p>+359 885 777 310</p>
            </div>
          </div>
          <div className="icon-element">
            <div className="icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="35"
                height="24"
                viewBox="0 0 35 24"
                fill="none"
              >
                <rect
                  x="1.5"
                  y="1"
                  width="31.5564"
                  height="22"
                  rx="2"
                  stroke="#343434"
                  strokeWidth="2"
                />
                <path
                  d="M1.5 6.5L16.4352 13.4415C16.9697 13.69 17.5866 13.69 18.1211 13.4415L33.0564 6.5"
                  stroke="#343434"
                  strokeWidth="2"
                />
              </svg>
            </div>
            <div className="info">
              <a href="mailto:dragalevtsi@alexfish.bg">
                dragalevtsi@alexfish.bg
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="right">
        <div className="title">
          <p>{t("social-media")}</p>
        </div>
        <div className="social-media">
          <div className="media">
            <a
              href="https://www.instagram.com/alexfish_sushi_seafood/"
              target="_blank"
              rel="noreferrer"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="33"
                height="32"
                viewBox="0 0 33 32"
                fill="none"
              >
                <g clipPath="url(#clip0_260_1720)">
                  <path
                    d="M16.5 2.88125C20.775 2.88125 21.2813 2.9 22.9625 2.975C24.525 3.04375 25.3688 3.30625 25.9313 3.525C26.675 3.8125 27.2125 4.1625 27.7688 4.71875C28.3313 5.28125 28.675 5.8125 28.9625 6.55625C29.1813 7.11875 29.4438 7.96875 29.5125 9.525C29.5875 11.2125 29.6063 11.7188 29.6063 15.9875C29.6063 20.2625 29.5875 20.7688 29.5125 22.45C29.4438 24.0125 29.1813 24.8563 28.9625 25.4188C28.675 26.1625 28.325 26.7 27.7688 27.2563C27.2063 27.8188 26.675 28.1625 25.9313 28.45C25.3688 28.6688 24.5188 28.9313 22.9625 29C21.275 29.075 20.7688 29.0938 16.5 29.0938C12.225 29.0938 11.7188 29.075 10.0375 29C8.475 28.9313 7.63125 28.6688 7.06875 28.45C6.325 28.1625 5.7875 27.8125 5.23125 27.2563C4.66875 26.6938 4.325 26.1625 4.0375 25.4188C3.81875 24.8563 3.55625 24.0063 3.4875 22.45C3.4125 20.7625 3.39375 20.2563 3.39375 15.9875C3.39375 11.7125 3.4125 11.2063 3.4875 9.525C3.55625 7.9625 3.81875 7.11875 4.0375 6.55625C4.325 5.8125 4.675 5.275 5.23125 4.71875C5.79375 4.15625 6.325 3.8125 7.06875 3.525C7.63125 3.30625 8.48125 3.04375 10.0375 2.975C11.7188 2.9 12.225 2.88125 16.5 2.88125ZM16.5 0C12.1563 0 11.6125 0.01875 9.90625 0.09375C8.20625 0.16875 7.0375 0.44375 6.025 0.8375C4.96875 1.25 4.075 1.79375 3.1875 2.6875C2.29375 3.575 1.75 4.46875 1.3375 5.51875C0.94375 6.5375 0.66875 7.7 0.59375 9.4C0.51875 11.1125 0.5 11.6562 0.5 16C0.5 20.3438 0.51875 20.8875 0.59375 22.5938C0.66875 24.2938 0.94375 25.4625 1.3375 26.475C1.75 27.5313 2.29375 28.425 3.1875 29.3125C4.075 30.2 4.96875 30.75 6.01875 31.1562C7.0375 31.55 8.2 31.825 9.9 31.9C11.6063 31.975 12.15 31.9937 16.4938 31.9937C20.8375 31.9937 21.3813 31.975 23.0875 31.9C24.7875 31.825 25.9563 31.55 26.9688 31.1562C28.0188 30.75 28.9125 30.2 29.8 29.3125C30.6875 28.425 31.2375 27.5313 31.6438 26.4813C32.0375 25.4625 32.3125 24.3 32.3875 22.6C32.4625 20.8938 32.4813 20.35 32.4813 16.0063C32.4813 11.6625 32.4625 11.1188 32.3875 9.4125C32.3125 7.7125 32.0375 6.54375 31.6438 5.53125C31.25 4.46875 30.7063 3.575 29.8125 2.6875C28.925 1.8 28.0313 1.25 26.9813 0.84375C25.9625 0.45 24.8 0.175 23.1 0.1C21.3875 0.01875 20.8438 0 16.5 0Z"
                    fill="#343434"
                  />
                  <path
                    d="M16.5 7.78125C11.9625 7.78125 8.28125 11.4625 8.28125 16C8.28125 20.5375 11.9625 24.2188 16.5 24.2188C21.0375 24.2188 24.7188 20.5375 24.7188 16C24.7188 11.4625 21.0375 7.78125 16.5 7.78125ZM16.5 21.3312C13.5563 21.3312 11.1687 18.9438 11.1687 16C11.1687 13.0563 13.5563 10.6687 16.5 10.6687C19.4438 10.6687 21.8312 13.0563 21.8312 16C21.8312 18.9438 19.4438 21.3312 16.5 21.3312Z"
                    fill="#343434"
                  />
                  <path
                    d="M26.9625 7.45635C26.9625 8.51885 26.1 9.3751 25.0438 9.3751C23.9813 9.3751 23.125 8.5126 23.125 7.45635C23.125 6.39385 23.9875 5.5376 25.0438 5.5376C26.1 5.5376 26.9625 6.4001 26.9625 7.45635Z"
                    fill="#343434"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_260_1720">
                    <rect
                      width="32"
                      height="32"
                      fill="white"
                      transform="translate(0.5)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </a>
          </div>
          <div className="media">
            <a
              href="https://www.facebook.com/alexfish.seafood"
              target="_blank"
              rel="noreferrer"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="33"
                height="32"
                viewBox="0 0 33 32"
                fill="none"
              >
                <g clipPath="url(#clip0_260_1722)">
                  <path
                    d="M32.5 16C32.5 7.16344 25.3366 0 16.5 0C7.66344 0 0.5 7.16344 0.5 16C0.5 23.9859 6.35094 30.6053 14 31.8056V20.625H9.9375V16H14V12.475C14 8.465 16.3888 6.25 20.0434 6.25C21.7934 6.25 23.625 6.5625 23.625 6.5625V10.5H21.6075C19.62 10.5 19 11.7334 19 13V16H23.4375L22.7281 20.625H19V31.8056C26.6491 30.6053 32.5 23.9859 32.5 16Z"
                    fill="#343434"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_260_1722">
                    <rect
                      width="32"
                      height="32"
                      fill="white"
                      transform="translate(0.5)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </a>
          </div>
        </div>
      </div>
      {openDeliveryPopup && (
        <div className="delivery-popup-wrap">
          <div className="delivery-popup-body">
            <div className="close">
              <button onClick={() => setOpenDeliveryPopup(false)}></button>
            </div>
            <h1>Доставка</h1>
            <p>
              <span>Поръчай прясна и вкусна храна в няколко лесни стъпки:</span>
              <br /> <br />
              1.Сложете желаните продукти в кошницата.
              <br />
              2.Попълнете своите данни за контакт и адрес за доставка.
              <br />
              3.Изберете начин на доставка и плащане.
              <br />
              4.Потвърдете поръчката.
              <br /> <br />
              Ще получите съобщение, когато поръчката Ви е приета и пътува към
              Вас.
              <br /> Минималната стойност за доставка е{" "}
              {Number(30 / 1.95583).toFixed(2)}€/30 лв. <br />
              Цена на доставка: {Number(6 / 1.95583).toFixed(2)}€/6 лв. <br />
              Безплатна доставка за поръчки над{" "}
              {Number(100 / 1.95583).toFixed(2)}€/100 лв.
            </p>
          </div>
        </div>
      )}
    </footer>
  );
}
